import { render } from "./SecureImage.vue?vue&type=template&id=52946df7"
import script from "./SecureImage.vue?vue&type=script&lang=js"
export * from "./SecureImage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__